<template>
   <div
      class="ancillary-seat-map-passenger-container"
      @click="handlerSelectSeat"
      :class="{ selected: SeatSelected, active: IsPassengerSelectionActive, noPointer: IsPassengerInfant, initialSeat: passenger.initialSeat }">
      <div class="passenger-cta" :class="{ active: IsPassengerSelectionActive }">
         <div class="passenger-cta-btn"></div>
      </div>

      <div class="passenger-information-container" v-if="IsPassengerInfant">
         <div class="row">
            <div class="col">
               <span class="info-label">{{ passenger.paxType }} {{ $t("ancillarySeatMap_lblPassenger") }}</span>
               <span>{{ passenger.paxName }} </span>
            </div>
            <div class="col">
               <span class="info-label">{{ $t("ancillarySeatMap_lblSeat") }}</span>

               <span>{{ passenger.seat }} </span>
            </div>
         </div>
      </div>
      <div class="passenger-information-container" v-else>
         <div class="row">
            <div class="col">
               <span class="info-label">{{ $t("ancillarySeatMap_lblPassenger") }}</span>
               <span>{{ passenger.paxName.trimmer(11) }} </span>
            </div>
            <div class="col" v-show="!InitialSeat">
               <span class="info-label">{{ $t("ancillarySeatMap_lblPrice") }}</span>

               <span>{{ passenger.price ?? "-" | price(currency) }} </span>
            </div>
         </div>
         <div class="row">
            <div class="col">
               <span class="info-label">{{ $t("ancillarySeatMap_lblPaxType") }}</span>
               <span>{{ passenger.paxType }} </span>
            </div>
            <div class="col">
               <span class="info-label">{{ $t("ancillarySeatMap_lblSeat") }}</span>
               <span>{{ passenger.seat }} - {{ passenger.cabinType }}</span>
            </div>
         </div>
      </div>

      <div class="cancel-seat-btn" :style="{ visibility: SeatSelected && !IsPassengerInfant ? '' : 'hidden' }">
         <button @click="handlerCancelSeat">{{ $t("ancillarySeatMap_lblCancel") }}</button>
      </div>

      <!-- <div class="infant-info-wrapper" v-if="IsPassengerInfant">
         {{ passenger.paxType }}
      </div> -->
   </div>
</template>

<script>
// import UITooltip from "@/components/utils/GtsToolTips.vue";
export default {
   name: "AncillarySeatMap",
   props: {
      passenger: Object,
      currency: String,
   },
   components: {
      // UITooltip,
   },
   computed: {
      IsPassengerSelectionActive() {
         return this.passenger.selected;
      },
      IsPassengerInfant() {
         return this.passenger.paxTypeEnum == 3;
      },
      SeatSelected() {
         return this.passenger.seat != null;
      },
      InitialSeat() {
         return this.passenger.initialSeat;
      },
   },
   methods: {
      handlerSelectSeat() {
         if (!this.IsPassengerInfant && !this.InitialSeat) {
            this.$store.dispatch("seatmap/updatePaxSelection", this.passenger);
         }
      },

      handlerCancelSeat() {
         this.$store.commit("seatmap/cancelSeatSelection", this.passenger);
      },
   },
};
</script>

<style lang="scss" scoped>
.ancillary-seat-map-passenger-container {
   display: flex;

   padding: 0.5rem 0.75rem;
   border-radius: 0.5rem;
   margin: 1rem 0;
   width: fit-content;
   min-width: 350px;
   cursor: pointer;

   outline-color: var(--gray-200);
   outline-style: solid;

   &.selected {
      background-color: var(--cyan-0);
      outline: 1.5px solid var(--blue-100);
      color: var(--primary);
   }
   &.active {
      outline: 2.5px solid var(--accent-primary);
      color: var(--primary);
      cursor: default !important;
      /* box-shadow: var(--gray-1000-alpha-75) 0px 0px 5px 0px, var(--gray-1000-alpha-75) 0px 0px 1px 0px; */
      box-shadow: var(--gts-box-shadow);
   }

   &.initialSeat {
      cursor: not-allowed !important;

      .passenger-cta,
      .cancel-seat-btn {
         visibility: hidden;
      }
   }

   &.noPointer {
      cursor: not-allowed;

      .passenger-cta {
         visibility: hidden;
         .passenger-cta-btn {
            border: 3px solid var(--gray-200);
            outline: 3px solid var(--gray-200);

            &::after {
               content: "";
               width: 70%;
               height: 70%;
               display: flex;
               border-radius: 50%;
            }
         }
      }
      &:hover {
         background-color: var(--gray-50) !important;
      }
   }
   &:hover {
      background-color: var(--green-0);
      background-color: var(--gray-200);
   }

   .passenger-information-container {
      width: 100%;

      .row {
         margin-bottom: 0.5rem;

         &:last-child {
            margin-bottom: 0 !important;
         }
         .col {
            display: flex;
            flex-direction: column;
            width: fit-content;

            span {
               white-space: nowrap;
               font-weight: 500;
               font-size: 1rem;

               &.info-label {
                  font-weight: 400;
                  font-size: 0.85rem;
                  opacity: 0.75;
               }
            }
         }
      }
   }
   .passenger-cta {
      display: flex;
      align-items: center;
      margin-right: 1rem;

      &.active {
         .passenger-cta-btn {
            &::after {
               background-color: var(--accent-primary);
            }
         }
      }

      .passenger-cta-btn {
         display: block;
         $size: 28px;
         width: $size;
         height: $size;
         //background-color: var(--gray-50);
         background-color: var(--gray-0);
         border: 3px solid var(--accent-primary);
         outline: 3px solid var(--blue-100);
         border-radius: 25rem;
         display: flex;
         align-items: center;
         justify-content: center;

         &::after {
            content: "";
            width: 70%;
            height: 70%;
            display: flex;
            border-radius: 50%;
         }
      }
   }
   .cancel-seat-btn {
      display: flex;
      align-items: center;

      button {
         background-color: var(--orange-400);
         background-color: var(--gray-800);
         background-color: var(--red-400);

         padding: 0.65rem 1rem;
         //color: var(--gray-50);
         color: var(--gray-0);
         border-radius: 0.5rem;
         font-weight: 600;
         font-size: var(--small);

         &:hover {
            background-color: var(--red-600);
         }
      }
   }
}
</style>
